<template>
  <div class="position-relative w-100">
    <b-form-input
      ref="input_ref"
      :disabled="isDisabled"
      :state="state"
      v-model="query"
      placeholder="Вид работ объекта"
      autocomplete="off"
      @focus="onFocusIn"
      @blur="onFocusOut"
      @click="isFocus = true"
    />

    <div class="select-input-body-wrapper">
      <span v-if="selectedItem && !isFocus" class="meta-info text-muted">
        {{ selectedItem.rate }} {{ getUnitByCode(selectedItem.unit_code).shortName }}
      </span>

      <button type="button" class="custom-btn-select" :disabled="isDisabled" @mousedown.prevent="onClick">
        <v-icon v-if="query" name="buttons/cross" :size="11"/>
        <v-icon v-else-if="isFocus" name="buttons/collapse_chevrons_down" :size="10"/>
        <v-icon v-else name="buttons/collapse_chevrons_right" :size="10"/>
      </button>
    </div>

    <div v-if="isFocus" class="custom-dropdown-select">
      <div class="custom-dropdown-list-scroll">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="custom-dropdown-select-item"
          @mousedown.prevent="onSelect(item)"
        >
          <div class="d-flex justify-content-between text-small w-100">
            {{ item.work_type_name }}
            <span class="meta-info text-muted">
              {{ item.rate }} {{ getUnitByCode(item.unit_code).shortName }}
            </span>
          </div>
        </div>
      </div>

      <div v-if="filteredItems.length === 0 && query" class="empty-state-container p-2">
        <v-icon name="navbar/empty_table" :size="45"/>
        <small class="text-muted">Ничего не найдено</small>
      </div>
    </div>
  </div>
</template>

<script>
import locations from "../../network/locations";
  import unitStore from "../../utilites/unitStore";

export default {
  name: "LocationWorksSelect",
  mixins: [
    locations,
    unitStore
  ],
  props: {
    isDisabled: { type: Boolean, default: false },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isFocus: false,
      query: "",
      items: [],
      selectedItem: null,
    }
  },
  computed: {
    filteredItems() {
      const query = this.query ? this.query.trim().toLowerCase() : '';

      if (!query) return this.items;

      if (this.selectedItem && this.selectedItem.work_type_name.toLowerCase() === query) {
        return this.items;
      }

      return this.items.filter(item => item.work_type_name.toLowerCase().includes(query));
    }
  },
  watch: {
    value: {
      handler(newValue) {
        if (newValue) this.configure(newValue);
      }, immediate: true
    },
  },
  methods: {
    async configure(id, items) {
      this.items = items || [];

      if (id && id > 0) {
        const result = await this.getLocationWorkById(id);

        if (result && result.data) {
          this.selectedItem = result.data;
          this.query = this.selectedItem.work_type_name
          return;
        }
      }

      this.onClear();
    },
    async onFocusIn() {
      this.isFocus = true;
    },
    onFocusOut() {
      this.isFocus = false;

      if (this.selectedItem) {
        if (this.query !== this.selectedItem.work_type_name) {
          this.query = this.selectedItem.work_type_name;
        }
      } else {
        this.query = '';
      }
    },
    onClick() {
      if (this.query) {
        this.onClear();
        this.$refs.input_ref.$el.focus();
      } else {
        this.onFocusIn();
        this.$refs.input_ref.$el.focus();
      }
    },
    onSelect(item) {
      this.query = item.work_type_name;
      this.selectedItem = item;
      this.$emit('onSelect', item);
      this.isFocus = false;
    },
    onClear() {
      this.query = '';
      this.selectedItem = null;
      this.$emit('onSelect', null);
    },
  },
}
</script>

<style>
.meta-info {
  font-size: 0.85rem;
  background-color: #f8f9fa;
  padding: 2px 8px;
  border-radius: 4px;
  color: #6c757d;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationWorksSelect.vue